@if (wellSegment.casingType.definition !== undefined) {
  @if (wellSegment) {
    <ag-grid-angular class="data-grid gis-ag-grid "
      [rowData]="segmentData"
      [columnDefs]="segmentColumnDefs"
      (gridReady)="segmentGridOnReady($event)"
      style="height: auto !important"
      [gridOptions]="segmentGridOptions" aria-label="Well Segment Precis">
    </ag-grid-angular>
  }
}